import React, { useState, useEffect } from 'react'

const Loader = ({ Logo }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prevProgress + 1;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50">
      <div className="w-80 bg-white/10 backdrop-blur-lg p-8 rounded-3xl shadow-2xl border border-white/20 flex flex-col items-center space-y-8 relative overflow-hidden">
        {/* Animated background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-gray-900/30 to-black/40 animate-gradient-shift"></div>

        {/* Glowing accent */}
        <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-[#f36812]/30 blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-24 -left-24 w-48 h-48 rounded-full bg-[#f36812]/20 blur-3xl animate-pulse delay-700"></div>

        {/* Content Container */}
        <div className="z-10 flex flex-col items-center space-y-8 w-full">
          {/* Logo with spinning ring effect */}
          <div className="relative flex items-center justify-center">
            <div className="absolute w-24 h-24 rounded-full border-t-2 border-r-2 border-[#f36812] animate-spin"></div>
            <div className="absolute w-24 h-24 rounded-full border-b-2 border-l-2 border-[#f36812]/50 animate-spin animation-delay-500 animate-reverse"></div>
            <div className="bg-white/90 w-20 h-20 rounded-full flex items-center justify-center p-2 shadow-lg">
              <img
                src={Logo}
                alt="Rayane Logo"
                className="w-16 h-16 object-contain"
              />
            </div>
          </div>

          {/* Progress bar */}
          <div className="w-full space-y-3">
            <div className="relative w-full h-2 bg-gray-200/30 rounded-full overflow-hidden">
              <div
                className="absolute top-0 left-0 h-full bg-gradient-to-r from-[#f36812]/80 to-[#f36812] rounded-full"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-white/90 text-sm font-medium">Loading resources</p>
              <p className="text-white/90 text-sm font-medium">{progress}%</p>
            </div>
          </div>

          {/* Premium text animation */}
          <div className="text-center">
            <p className="text-white font-medium tracking-wide text-lg">
              Please Wait
            </p>
            <p className="text-white/70 text-sm mt-1">
              Preparing your premium experience
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader